export const loadImage = (src: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    // Work only if the server response headers contains [Access-Control-Allow-Origin: *]
    image.crossOrigin = 'Anonymous';
    image.onload = () => {
      resolve(image);
    };
    image.src = src;
    image.onerror = () => {
      const error = new Error(`Image <<${src}>> is not loaded.`);
      reject(error);
    };
  });
};

export const mousePosition = (
  event: TouchEvent,
  element: HTMLElement
): number[] => {
  const zone: { top: number; left: number } = getOffset(element);

  const posX = event.touches[0].clientX - zone.left;
  const posY = event.touches[0].clientY - zone.top;

  return [posX, posY];
};

export const getOffset = (
  element: HTMLElement
): {
  left: number;
  top: number;
} => {
  const offset = {
    left: 0,
    top: 0,
  };

  const clientRect = element.getBoundingClientRect();

  while (element) {
    offset.top += element.offsetTop;
    offset.left += element.offsetLeft;
    element = <HTMLElement>element.offsetParent;
  }

  // Calculate the delta between offset values and clientRect values
  const deltaLeft = offset.left - clientRect.left;
  const deltaTop = offset.top - clientRect.top;

  return {
    left:
      deltaLeft < 0
        ? offset.left + Math.abs(deltaLeft)
        : offset.left - Math.abs(deltaLeft),
    top:
      deltaTop < 0
        ? offset.top + Math.abs(deltaTop)
        : offset.top - Math.abs(deltaTop),
  };
};
